export const CREATE_WORKOUT = 'CREATE_WORKOUT'
export const CREATE_WORKOUT_LOADING = 'CREATE_WORKOUT_LOADING'
export const CREATE_WORKOUT_ERROR = 'CREATE_WORKOUT_ERROR'
export const CREATE_WORKOUT_SUCCESS = 'CREATE_WORKOUT_SUCCESS'

export const UPDATE_WORKOUT = 'UPDATE_WORKOUT'
export const UPDATE_WORKOUT_LOADING = 'UPDATE_WORKOUT_LOADING'
export const UPDATE_WORKOUT_ERROR = 'UPDATE_WORKOUT_ERROR'
export const UPDATE_WORKOUT_SUCCESS = 'UPDATE_WORKOUT_SUCCESS'

export const FETCH_CALORIES = 'FETCH_CALORIES'
export const FETCH_CALORIES_LOADING = 'FETCH_CALORIES_LOADING'
export const FETCH_CALORIES_ERROR = 'FETCH_CALORIES_ERROR'
export const FETCH_CALORIES_SUCCESS = 'FETCH_CALORIES_SUCCESS'

export const FETCH_WORKOUT = 'FETCH_WORKOUT'
export const FETCH_WORKOUT_LOADING = 'FETCH_WORKOUT_LOADING'
export const FETCH_WORKOUT_SUCCESS = 'FETCH_WORKOUT_SUCCESS'
export const FETCH_WORKOUT_ERROR = 'FETCH_WORKOUT_ERROR'

export const FETCH_WORKOUT_COPY = 'FETCH_WORKOUT_COPY'
export const FETCH_WORKOUT_COPY_LOADING = 'FETCH_WORKOUT_COPY_LOADING'
export const FETCH_WORKOUT_COPY_ERROR = 'FETCH_WORKOUT_COPY_ERROR'
export const FETCH_WORKOUT_COPY_SUCCESS = 'FETCH_WORKOUT_COPY_SUCCESS'

export const FETCH_USER_WORKOUTS = 'FETCH_USER_WORKOUTS'
export const FETCH_USER_WORKOUTS_LOADING = 'FETCH_USER_WORKOUTS_LOADING'
export const FETCH_USER_WORKOUTS_ERROR = 'FETCH_USER_WORKOUTS_ERROR'
export const FETCH_USER_WORKOUTS_SUCCESS = 'FETCH_USER_WORKOUTS_SUCCESS'

export const FETCH_USER_WORKOUTS_WITH_ROUTE = 'FETCH_USER_WORKOUTS_WITH_ROUTE'
export const FETCH_USER_WORKOUTS_WITH_ROUTE_LOADING = 'FETCH_USER_WORKOUTS_WITH_ROUTE_LOADING'
export const FETCH_USER_WORKOUTS_WITH_ROUTE_ERROR = 'FETCH_USER_WORKOUTS_WITH_ROUTE_ERROR'
export const FETCH_USER_WORKOUTS_WITH_ROUTE_SUCCESS = 'FETCH_USER_WORKOUTS_WITH_ROUTE_SUCCESS'
